"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgZap = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M22.867 27H15a1 1 0 01-.768-1.64l10-12c.639-.767 1.884-.227 1.76.764L25.132 21H33a1 1 0 01.768 1.64l-10 12c-.639.767-1.884.227-1.76-.764l.86-6.876zm.718-9.74L17.135 25H24a1 1 0 01.992 1.124l-.577 4.616 6.45-7.74H24a1 1 0 01-.992-1.124l.577-4.616z",
    id: "zap_svg__a"
  }));
};

var _default = SvgZap;
exports.default = _default;